import { getAppParamKey } from "util/application";

import { INTEGRATION_TYPES } from "./device";

const APP_ID_ADS = "com.vistarmedia.apps.ads";
const APP_ID_ALL = -4;
const APP_ID_PLAYER = -2;
const APP_ID_SINGLE_ZONE_SCHEDULER = "com.vistarmedia.schedulers.single-zone";
const APP_ID_STEM = -5;
const BLACK_SCREEN_APP_ID = "__bs";

const VISTAR_APP_IDS = {
  APP_ID_ADS,
  APP_ID_ALL,
  APP_ID_PLAYER,
  APP_ID_SINGLE_ZONE_SCHEDULER,
  APP_ID_STEM,
};
const APP_MANIFEST_V2 = 2;
const APP_MANIFEST_V3 = 3;

const PARAM_TYPE_ARRAY = "ARRAY";
const PARAM_TYPE_BOOLEAN = "BOOLEAN";
const PARAM_TYPE_NUMBER = "NUMBER";
const PARAM_TYPE_STRING = "STRING";
const APP_PARAM_TYPES = [
  PARAM_TYPE_ARRAY,
  PARAM_TYPE_BOOLEAN,
  PARAM_TYPE_NUMBER,
  PARAM_TYPE_STRING,
];
const EMPTY_VALUE = {
  [PARAM_TYPE_STRING]: "",
  [PARAM_TYPE_NUMBER]: null,
  [PARAM_TYPE_BOOLEAN]: null,
  [PARAM_TYPE_ARRAY]: [],
};

// TODO(etsai): cor-3119: We might want to fetch business logic from api
//  instead of implementing logic on UI.
const ADS_APP_PARAMS = {
  API_KEY: getAppParamKey(APP_ID_ADS, "api_key"),
  HEIGHT: getAppParamKey(APP_ID_ADS, "height"),
  NETWORK_ID: getAppParamKey(APP_ID_ADS, "network_id"),
  STATIC_DURATION: getAppParamKey(APP_ID_ADS, "static_duration"),
  SUPPORTED_MEDIA: getAppParamKey(APP_ID_ADS, "supported_media"),
  URL: getAppParamKey(APP_ID_ADS, "url"),
  VENUE_ID: getAppParamKey(APP_ID_ADS, "venue_id"),
  WIDTH: getAppParamKey(APP_ID_ADS, "width"),
};

const SYSTEM_MANAGED_APPS = [APP_ID_ADS];
const SYSTEM_MANAGED_NETWORK_PARAMS = [
  ADS_APP_PARAMS.API_KEY,
  ADS_APP_PARAMS.NETWORK_ID,
  ADS_APP_PARAMS.URL,
];
const SYSTEM_MANAGED_DEVICE_PARAMS = {
  [INTEGRATION_TYPES.AGENT]: [ADS_APP_PARAMS.VENUE_ID],
  [INTEGRATION_TYPES.PLAYER]: [
    ADS_APP_PARAMS.HEIGHT,
    ADS_APP_PARAMS.SUPPORTED_MEDIA,
    ADS_APP_PARAMS.VENUE_ID,
    ADS_APP_PARAMS.WIDTH,
  ],
  [INTEGRATION_TYPES.THIRDPARTY]: [
    ADS_APP_PARAMS.HEIGHT,
    ADS_APP_PARAMS.STATIC_DURATION,
    ADS_APP_PARAMS.SUPPORTED_MEDIA,
    ADS_APP_PARAMS.VENUE_ID,
    ADS_APP_PARAMS.WIDTH,
  ],
};

export {
  APP_ID_ADS,
  APP_ID_ALL,
  APP_ID_PLAYER,
  APP_ID_SINGLE_ZONE_SCHEDULER,
  APP_ID_STEM,
  APP_MANIFEST_V2,
  APP_MANIFEST_V3,
  APP_PARAM_TYPES,
  BLACK_SCREEN_APP_ID,
  EMPTY_VALUE,
  PARAM_TYPE_ARRAY,
  PARAM_TYPE_BOOLEAN,
  PARAM_TYPE_NUMBER,
  PARAM_TYPE_STRING,
  SYSTEM_MANAGED_APPS,
  SYSTEM_MANAGED_DEVICE_PARAMS,
  SYSTEM_MANAGED_NETWORK_PARAMS,
  VISTAR_APP_IDS,
};
